export default function getEnv() {
  //
  const domain = window?.location?.hostname;
  if (
    domain === 'test-platform.creator.ahaglobal.io' ||
    domain === 'test.platform.creator.aha.inc' ||
    domain === 'localhost' ||
    domain.includes('amplifyapp')
  ) {
    return 'development';
  }
  if (
    domain === 'platform.creator.ahaglobal.io' ||
    domain === 'platform.creator.aha.inc'
  ) {
    return 'production';
  }
  return 'production';
}
